import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemHeroActions = (props: PropsWithChildren) => {
  const { children } = props;

  return <View style={styles.container}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'stretch',
    gap: theme.spacing['3'],
    paddingTop: theme.spacing['4'],
  },
});
